export default "/_next/static/images/222e9e5b61322e53577164467069fc2b.png";